<p-dialog [(visible)]="visible"
		  [baseZIndex]="10000"
		  [modal]="true"
		  [closeOnEscape]="false"
		  [draggable]="true"
		  [keepInViewport]="false"
		  [resizable]="false"
		  [focusOnShow]="false"
		  [ngClass]="confirmationData?.modaleStyleClass"
		  [closable]="confirmationData?.closable && !loading"
		  styleClass="modale-small">
	<p-header>
		{{confirmationData?.titre | translate}}
	</p-header>
	<alert *ngIf="afficherAlerteSimple()" nom="confirmationModalAlert"></alert>
	<alert *ngIf="afficherAlerteAvecUnBouton()" nom="confirmationModalAlertWithBouton"
	       [nomBouton]="confirmationData?.alertData?.nomBouton1"
	></alert>
	<alert *ngIf="afficherAlerteAvecDeuxBoutons()" nom="confirmationModalAlertWith2Boutons"
	       [nomBouton]="confirmationData?.alertData?.nomBouton1"
	       [nomBouton2]="confirmationData?.alertData?.nomBouton2"
	></alert>
	<div class="container-fluid">
		<p>{{ confirmationData?.message | translate:confirmationData?.translateParams }}</p>
		<div *ngIf="confirmationData?.messageInformation" class="message-information">
			<span>{{ confirmationData?.messageInformation | translate:confirmationData?.translateParamsMessageInformation }}</span>
		</div>
	</div>

	<p-footer>
		<div class="footer-confirmation" *ngIf="!loading">
			<div *ngFor="let action of confirmationData?.actions" [ngSwitch]="action.type" class="d-flex">
				<p-button *ngSwitchCase="'link'"
						  type="button"
						  [ngClass]="action.cssClass"
						  styleClass="p-button-link"
						  label="{{ action.label | translate }}"
						  (click)="onClick(action)"></p-button>
				<p-button *ngSwitchDefault
						  type="button"
						  [ngClass]="action.cssClass"
						  (click)="onClick(action)"
						  label="{{ action.label | translate }}"
						  icon="{{ action.icon }}">
				</p-button>
			</div>
		</div>
		<span *ngIf="loading" class="app-spinner m-2"></span>
	</p-footer>
</p-dialog>
